// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bot-config-field {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.bot-config-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
}

.bot-config-textarea {
  resize: vertical;
  min-height: 60px;
  font-family: var(--font-family-mono);
  line-height: var(--line-height-normal);
}

.bot-config-loading {
  text-align: center;
  padding: var(--spacing-xl);
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
}
`, "",{"version":3,"sources":["webpack://./../../../packages/apps/myagent/myagent_ui/src/components/BotConfigModal.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC","sourcesContent":["@import '../styles/variables.css';\n\n.bot-config-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n.bot-config-label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-secondary);\n}\n\n.bot-config-textarea {\n  resize: vertical;\n  min-height: 60px;\n  font-family: var(--font-family-mono);\n  line-height: var(--line-height-normal);\n}\n\n.bot-config-loading {\n  text-align: center;\n  padding: var(--spacing-xl);\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
